class BioactiveHeroSlider extends HTMLElement {
  connectedCallback() {
    // connectedCallback can fire more than once (e.g. when the node is moved or
    // re-inserted in the DOM). Initializing Swiper on every fire stacks multiple
    // instances on the same element, leaving orphaned pagination bullets that no
    // longer track the active slide and don't respond to clicks. Guard so the
    // slider is initialized only once.
    if (this.swiperInstance) return;

    const carousel = this.querySelector('.bioactive-hero-slider__carousel');
    const SwiperCtor = /** @type {any} */ (window).Swiper;
    if (!carousel || !SwiperCtor) return;

    // Clear any stale bullets left behind by a previous initialization so the
    // pagination is rebuilt cleanly for the live instance.
    const pagination = this.querySelector('.swiper-pagination');
    if (pagination) pagination.innerHTML = '';

    const autoplayEnabled = this.dataset.autoplayEnabled === 'true';
    const parsedDelaySeconds = Number(this.dataset.autoplayDelay);
    const delaySeconds = Number.isFinite(parsedDelaySeconds) ? Math.max(0, parsedDelaySeconds) : 5;
    const shouldAutoplay = autoplayEnabled && delaySeconds > 0;

    /** @type {any} */
    const swiperConfig = {
      loop: true,
      pagination: {
        el: pagination,
        clickable: true,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
        pageUpDown: true,
      },
    };

    if (shouldAutoplay) {
      swiperConfig.autoplay = {
        delay: Math.round(delaySeconds * 1000),
        disableOnInteraction: false,
      };
    }

    this.swiperInstance = new SwiperCtor(carousel, swiperConfig);
  }
}

customElements.define('bioactive-hero-slider', BioactiveHeroSlider);
